import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, NgForm, ReactiveFormsModule } from '@angular/forms';
import { WorkService } from '../work.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-add-work',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './add-work.component.html',
  styleUrls: ['./add-work.component.scss']
})
export class AddWorkComponent implements OnInit {
  fGroup: FormGroup
  isLoading = false;
  router: any;
  constructor(private fb: FormBuilder, private workService: WorkService) {
    this.fGroup = this.fb.group({
      name: [''],
      description: [''],
      imageLink: ['']
    })
  }

  ngOnInit(): void {
  }

  doAddProject(){
    this.isLoading = true;
      this.workService.doAddDataWork(this.fGroup.value).subscribe((value: any) => {
        this.isLoading = false
        console.log(value, 'edit success');
        this.router.navigate([''])
      });

    }

}
